module.exports = __webpack_public_path__ + "static/media/cherrybeach.b338cbe6.jpg";